import { render, staticRenderFns } from "./talla.vue?vue&type=template&id=2cd8f47b&"
import script from "./talla.vue?vue&type=script&lang=js&"
export * from "./talla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports